<template>
  <el-table-column
    prop="ntax_partner.job_number"
    label="Munkaszám"
    width="150"
    sortable="custom"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <span
        v-if="scope.row.ntax_partner"
      >
        {{ scope.row.ntax_partner.job_number }}
      </span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'ntax_partner.job_number',
  };
</script>
